import { DashboardLayout } from '@/components/layout/DashboardLayout';
import EllaLearnAdmin from '@/components/compliance/EllaLearnAdmin';
import { useUserRoles } from '@/hooks/useUserRoles';

export default function EllaLearn() {
  const { hasRole } = useUserRoles();
  const isAdmin = hasRole('admin') || hasRole('owner');

  if (!isAdmin) {
    return (
      <DashboardLayout>
        <div className="p-6 text-center">
          <p className="text-muted-foreground">Access denied. Admin privileges required.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Ella Learn</h1>
          <p className="text-muted-foreground mt-2">
            Automated knowledge base ingestion and feed management
          </p>
        </div>
        <EllaLearnAdmin />
      </div>
    </DashboardLayout>
  );
}
